module.exports = __webpack_public_path__ + "media/images/web/instagram-54f4f87ebcda8e1504448d2e2e3179bd.svg";